module.exports = __webpack_public_path__ + "img/3e69f5a114cb44820b06e96919df3699.png";